// Controller for expanding and collapsing leisure section details on
// room cards.
//
// Note: It's very specific because it was ported from old Coffescript
// logic. If you're expanding it, consider reviewing other stimulus
// controllers and extracting a more reusable controller to cover
// multiple cases, if possible.
stimulusApp.register(
  "room-leisure",
  class extends Stimulus.Controller {
    connect() {
      this.element.addEventListener("click", this.toggle)
    }

    disconnect() {
      this.element.removeEventListener("click", this.toggle)
    }

    toggle = (event) => {
      event.preventDefault()
      event.stopPropagation()
      requestAnimationFrame(() => {
        this.element.classList.toggle("collapsible-room-leisure_expanded")
      })
    }
  },
)
